import { defineComponent as k, createElementBlock as t, openBlock as e, createElementVNode as h, Fragment as l, renderList as o, unref as c, createBlock as f, createCommentVNode as b } from "vue";
import { isHttpMethod as C } from "@scalar/helpers/http/is-http-method";
import { getResolvedRef as g } from "@scalar/workspace-store/helpers/get-resolved-ref";
import y from "./Callback.vue.js";
const v = { class: "callbacks-list gap-3" }, N = /* @__PURE__ */ k({
  __name: "Callbacks",
  props: {
    path: {},
    method: {},
    callbacks: {},
    schemas: {}
  },
  setup(m) {
    return (a, s) => (e(), t("div", v, [
      s[0] || (s[0] = h("div", { class: "callbacks-title text-c-1 my-3 text-lg font-medium" }, " Callbacks ", -1)),
      (e(!0), t(l, null, o(a.callbacks, (u, n) => (e(), t(l, { key: n }, [
        (e(!0), t(l, null, o(c(g)(u), (p, i) => (e(), t(l, null, [
          (e(!0), t(l, null, o(p, (d, r) => (e(), t(l, { key: r }, [
            c(C)(r) ? (e(), f(y, {
              key: 0,
              callback: d,
              method: r,
              name: n,
              operationMethod: m.method,
              path: a.path,
              schemas: a.schemas,
              url: i
            }, null, 8, ["callback", "method", "name", "operationMethod", "path", "schemas", "url"])) : b("", !0)
          ], 64))), 128))
        ], 64))), 256))
      ], 64))), 128))
    ]));
  }
});
export {
  N as default
};
